export const getAccountBudgetPercentage = (accountBudget: number, invoicingBudget: number): number => {
  if (!invoicingBudget) return 0

  return (accountBudget / invoicingBudget) * 100
}
